import HeroBg from "public/encryptedStorage/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Secure your storage infrastructure today",
    link: "contact-us",
  },
  desc: "Protect mission-critical workloads with Encrypted Storage Clusters, ensuring data security, redundancy, and compliance.",
  title: "Secure & Resilient Storage for Sensitive Data",
  image: HeroBg,
};
